var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleIconsVv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13022_33606)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44ZM8.48308 32.3512C8.97075 32.8388 9.57875 33.0827 10.3071 33.0827H33.6929C34.4212 33.0827 35.0298 32.8383 35.5185 32.3496C36.0062 31.8619 36.25 31.2539 36.25 30.5256V13.4731C36.25 12.7448 36.0056 12.1368 35.5169 11.6491C35.0293 11.1604 34.4212 10.916 33.6929 10.916H10.3071C9.57875 10.916 8.97075 11.1604 8.48308 11.6491C7.99436 12.1368 7.75 12.7448 7.75 13.4731V30.5256C7.75 31.2539 7.99436 31.8625 8.48308 32.3512ZM34.3627 31.1953C34.1589 31.398 33.9357 31.4993 33.6929 31.4993H10.3071C10.0643 31.4993 9.84106 31.398 9.63733 31.1953C9.43467 30.9916 9.33333 30.7684 9.33333 30.5256V15.666H34.6667V30.5256C34.6667 30.7684 34.5653 30.9916 34.3627 31.1953ZM15.8123 23.5225L20.3375 28.0477L28.1877 20.1975L27.0477 19.0575L20.3375 25.7693L16.9523 22.3825L15.8123 23.5225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13022_33606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsVv);
export default __webpack_public_path__ + "static/media/simple-icons_vv.1056b536a26d24d0ba3093500416724e.svg";
export { ForwardRef as ReactComponent };